import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  HostListener,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import {
  CostAccordionCategory,
  DisplayItem,
} from '../production-cost.component';
import {
  CostItemService,
  ModalService,
  ItemGroupService,
  CostItem,
  Position,
  ItemGroup,
  CostItemComment,
  ItemGroupComment,
  AccordionCategory,
  LocalStorageService,
  ItemGroupCommentService,
} from '@ops/shared-types';
import { CommonModule } from '@angular/common';
import {
  // AddCostModule,
  CommentPopupModule,
  DropdownModule,
  EnterPressDirective,
  ActionMenuComponent,
  ActionMenuDirective,
  ActionMenuService,
  ActionMenuOption,
} from '@ops/components';
import {
  CostAccordionItemComponent,
  NameIdPair,
} from '../cost-accordion-item/cost-accordion-item.component';
import { Miscellanious } from '@ops/global-config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OpsMoveCostItemToDifferentDepartmentModule } from '@ops/storybook';
import { ProductionCostService } from '../production-cost.service';

@Component({
  selector: 'ops-cost-accordion',
  standalone: true,
  imports: [
    CommonModule,
    DropdownModule,
    CommentPopupModule,
    // AddCostModule,
    CostAccordionItemComponent,
    EnterPressDirective,
    TranslateModule,
    ActionMenuComponent,
    ActionMenuDirective,
    OpsMoveCostItemToDifferentDepartmentModule,
  ],
  templateUrl: './cost-accordion.component.html',
  styleUrls: ['./cost-accordion.component.scss'],
})
export class CostAccordionComponent implements OnInit, OnChanges {
  
  @Input() categories: Array<CostAccordionCategory> = [];
  @Input() projectId: string;
  @Input() companyId: string;
  @Input() renameId?: string;
  @Input() refreshTrigger?: boolean;
  @Output() recalculateTotal: EventEmitter<void> = new EventEmitter<void>();
  @Output() actionSelected: EventEmitter<{
    categoryId: string;
    selection: string;
  }> = new EventEmitter<{ categoryId: string; selection: string }>();
  @Output() moveItem: EventEmitter<DisplayItem> = new EventEmitter<DisplayItem>();
  @Output() addNewPaidByOption: EventEmitter<{ type: string }> = new EventEmitter<{ type: string }>();

  selectedItems: number;

  costTypeInput: string;
  positionInput: string;
  nameInput: string;
  daysInput: number;
  unitsInput: number;
  unitCostInput: number;
  costStatusInput: string;
  paymentMethodInput: string;
  paymentDateInput: Date;
  paymentDateString: string;
  dateOfBillInput: Date;
  dateOfBillString: string;
  expenseTypeInput: string;
  totalInput: number; //?
  taxInput: number;
  paidByInput: string;
  assignToInput: string;
  accountingCategoryInput: string;

  unit: string;
  days: string;
  cost: string;

  addCostDepartmentObject: { name: string; _id: string } = {
    _id: 'dummy',
    name: 'dummy',
  };

  newName: string;


  saveFlag: boolean;
  cancelFlag: boolean;
  selectAllFlag: boolean;
  categoryIdForSort?: string;

  sortBy: { field: string; ascending: boolean } = {
    field: '',
    ascending: false,
  };

  actionOptions: ActionMenuOption[] = [];
  companyCurrencyCode?: string;

  // Move item modal properties
  showMoveModal = false;
  selectedCostItem: any = null;
  availableDepartments: any[] = [];
  moveLoading = false;

  constructor(
    private modalService: ModalService,
    private changeDetector: ChangeDetectorRef,
    private groupDataService: ItemGroupService,
    private itemDataService: CostItemService,
    private localStorageService: LocalStorageService,
    private translateService: TranslateService,
    private productionCostService: ProductionCostService,
    private actionMenuService: ActionMenuService,
    private itemGroupCommentService: ItemGroupCommentService
  ) {
    this.companyCurrencyCode =
      this.localStorageService.getCurrentCompany()?.baseCurrencyCode;
  }

  ngOnInit(): void {
    this.selectedItems = 0;
    this.actionOptions = this.getCategoryActionMenuOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.renameId && changes.renameId.currentValue) {
      this.newName =
        this.categories.find((c) => c._id === changes.renameId.currentValue)
          ?.name || '';
    }
    
    // ✅ FIXED: Handle company changes to refresh payment methods
    if (changes.companyId && !changes.companyId.isFirstChange()) {
      // The companyId change will automatically propagate to child components
      // and trigger their ngOnChanges methods
    }
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  openModalAddCost(modalId: string, category?: CostAccordionCategory) {
    this.addCostDepartmentObject._id = category?._id;
    this.addCostDepartmentObject.name = category?.department;
    if (category) {
      this.modalService.open(modalId, {
        _id: category._id,
        name: category.department,
      });
      return;
    }
    this.modalService.open(modalId);
  }

  openCommentModal(id: string, category: CostAccordionCategory) {
    this.itemGroupCommentService
      .getItemGroupComments(category.project, category._id)
      .subscribe((comments: Array<ItemGroupComment>) => {
        category.comments = comments;
        category.comments.forEach((c) => (c.createdAt = new Date(c.createdAt)));
      });
    this.modalService.open(id);
  }

  onRecalculate(item: CostItem) {
    console.log('onRecalculate', item, item.currencyCode, this.companyCurrencyCode);
    const group = this.categories.find((c) => c._id === item.itemGroup);
    group.actual = group.items.reduce(
      (res, i) =>
        res +
        (i.currencyCode !== this.companyCurrencyCode
          ? i.exchangeRate * i.total
          : i.total),
      0
    );
    this.recalculateTotal.emit();
  }

  onItemDeleted(item: CostItem) {
    const category = this.categories.find((c) => c._id === item.itemGroup);
    category.items = category.items.filter((i) => i._id != item._id);
    this.onRecalculate(item);
  }

  onDuplicateItem(item: DisplayItem) {
    const newItem: CostItem = {
      color: item.color,
      cost: item.cost,
      days: item.days,
      name: item.name,
      orderNumber: item.orderNumber,
      position: item.position,
      project: item.project,
      units: item.units,
      accountingCategory: item.accountingCategory,
      assignedTo: item.assignedTo,
      costStatus: item.costStatus,
      costType: item.costType,
      dateOfBill: item.dateOfBill,
      hasReminder: item.hasReminder,
      paidBy: item.paidBy,
      paymentDate: item.paymentDate,
      paymentMethod: item.paymentMethod,
      description: item.description,
      exchangeRate: item.exchangeRate || 1,
      currencyCode: item.currencyCode,
      taxPercentage: item.taxPercentage,
    };

    this.itemDataService
      .createCostItemByGroup(
        item.itemGroup,
        newItem,
        item.project,
        this.companyId
      )
      .subscribe((i: DisplayItem) => {
        newItem.itemGroup = item.itemGroup;
        let cat = this.categories.find((d) => d._id === item.itemGroup);
        if (!cat) {
          cat = this.categories[0];
        }
        cat.items.push(i);
        this.categories = [...this.categories];

        if (item.cost || item.total) {
          this.onRecalculate(item);
        }
      });
  }

  onMoveItem(item: DisplayItem) {
    // console.log('onMoveItem FROM COST ACCORDION', item);
    this.selectedCostItem = {
      id: item._id,
      name: item.name,
      amount: item.cost || 0,
      department: item.itemGroup,
      description: item.description
    };
    
    // Convert categories to departments format expected by the modal
    this.availableDepartments = this.categories.map(category => ({
      id: category._id,
      name: category.department + (category.name ? ' ' + category.name : ''),
      code: category.department
    }));
    
    this.showMoveModal = true;
  }

  onMoveItemConfirmed(event: { costItemId: string; newDepartmentId: string }) {
    this.moveLoading = true;
    
    // Emit the move event to parent component
    this.moveItem.emit({
      ...this.selectedCostItem,
      newDepartmentId: event.newDepartmentId
    });
    
    this.moveLoading = false;
    this.showMoveModal = false;
    this.selectedCostItem = null;
  }

  onMoveItemCanceled() {
    this.showMoveModal = false;
    this.selectedCostItem = null;
  }

  get haveAnyAccordionOpen(): boolean {
    return !!this.categories.find((ci) => ci.open);
  }

  toggleAccordion(index) {
    if(this.categories[index].isLoaded) {
      this.categories[index].open = !this.categories[index].open;
      return;
    }
    // this.categories[index].isLoaded = true;
    // const items = this.productionCostService.getEstimateItems();
    // this.categories[index].items.forEach((item) => {
    //   const match = items.find((i) => i.itemLink === item.itemLink);
    //   item.estimatedCurrencyCode = match?.currencyCode ?? this.companyCurrencyCode;
    //   item.estimatedTotal = match?.total ?? 0;
    //   item.estimatedExchangeRate = match?.exchangeRate ?? 1;
    // });
    // this.categories[index].estimate = this.categories[index].items.reduce((res, item) => res + item.estimatedTotal, 0);
    // this.categories[index].items = [...this.categories[index].items];
    // this.changeDetector.markForCheck();
    this.categories[index].open = !this.categories[index].open;
  }

  onItemToggled(value: number) {
    this.selectedItems += value;
    if (this.selectedItems < 0) {
      this.selectedItems = 0;
    }

    if (this.selectedItems == 0) {
      this.onCancelMultiEdit();
    }
  }

  onToggleOrderBy(field: string, categoryId: string, event: any) {
    event.stopPropagation();
    if (this.sortBy?.field === field) {
      this.sortBy.ascending = !this.sortBy.ascending;
      this.sortItems(categoryId);
      this.categories = [...this.categories];
      return;
    }
    this.sortBy = { field: field, ascending: true };
    this.sortItems(categoryId);
  }

  sortItems(categoryId: string) {
    this.categoryIdForSort = categoryId;
    const criteria: string = this.sortBy.field;
    const order = this.sortBy.ascending ? 1 : -1;
    const items = this.categories?.find((c) => c._id === categoryId)?.items;
    items?.sort((a, b) => (a[criteria] > b[criteria] ? order : -order));

    // items
    // if (criteria === 'recordedAmount' && this.isProject) {
    //   criteria = 'total';
    // }
    // const order = this.sortBy.ascending ? -1 : 1;
    // if (this.companyItems) {
    //   this.companyItems = this.companyItems.sort((a, b) =>
    //     a[criteria] > b[criteria] ? 0 - order : order
    //   );
    // }
    // if (this.projectItems) {
    //   this.projectItems = this.projectItems.sort((a, b) =>
    //     a[criteria] > b[criteria] ? 0 - order : order
    //   );
    // }
    // if (this.incomeItems) {
    //   if (criteria === 'name') {
    //     this.incomeItems = this.incomeItems.sort((a, b) =>
    //       a.clientName > b.clientName ? 0 - order : order
    //     );
    //   }

    //   if (criteria === 'dateOfBill') {
    //     this.incomeItems = this.incomeItems.sort((a, b) =>
    //       a.invoiceDate > b.invoiceDate ? 0 - order : order
    //     );
    //   }

    //   if (criteria === 'paymentDate') {
    //     this.incomeItems = this.incomeItems.sort((a, b) =>
    //       a.paymentExpectedDate > b.paymentExpectedDate ? 0 - order : order
    //     );
    //   }

    //   if (criteria === 'expectedAmount') {
    //     this.incomeItems = this.incomeItems.sort((a, b) =>
    //       a.invoiceAmount > b.invoiceAmount ? 0 - order : order
    //     );
    //   }

    //   if (criteria === 'recordedAmount') {
    //     this.incomeItems = this.incomeItems.sort((a, b) =>
    //       a.receivedAmount > b.receivedAmount ? 0 - order : order
    //     );
    //   }
    // }
  }

  onEditCostType(value: string) {
    this.costTypeInput = value;
  }
  onEditPosition(value: string) {
    this.positionInput = value;
  }
  onEditName(event: any) {
    this.nameInput = event.target.value;
  }
  onEditPaymentMethod(value: string) {
    this.paymentMethodInput = value;
  }
  onEditPayedBy(value: string) {
    this.paidByInput = value;
  }

  onEditPaymentDate(value: Date) {
    this.paymentDateInput = value ?? null;
  }
  onEditDays(event: any) {
    this.daysInput = +event.target.value.toString().replaceAll(',', '');
  }
  onEditUnit(event: any) {
    this.unitsInput = +event.target.value.toString().replaceAll(',', '');
  }
  onEditUnitCost(event: any) {
    this.unitCostInput = +event.target.value.toString().replaceAll(',', '');
  }

  onEditCostStatus(value: string) {
    this.costStatusInput = value;
  }
  onEditdateOfBill(value: Date) {
    this.dateOfBillInput = value ?? null;
  }
  onEditAssignTo(value: string) {
    this.assignToInput = value;
  }
  onEditAccountingCategory(value: string) {
    this.accountingCategoryInput = value;
  }

  onToggleReminder() {
    window.alert(this.translateService.instant('windowAlert.costAccordion.underConstruction'));
  }

  onCancelMultiEdit() {
    this.costTypeInput = undefined;
    this.positionInput = undefined;
    this.nameInput = undefined;
    this.paymentMethodInput = undefined;
    this.paidByInput = undefined;
    this.paymentDateInput = undefined;
    this.paymentDateString = '';
    this.daysInput = undefined;
    this.unitsInput = undefined;
    this.unitCostInput = undefined;
    this.costStatusInput = undefined;
    this.dateOfBillInput = undefined;
    this.dateOfBillString = '';
    this.assignToInput = undefined;
    this.accountingCategoryInput = undefined;
    this.taxInput = undefined;
    this.cancelFlag = !this.cancelFlag;
    this.selectedItems = 0;

    this.sortItems(this.categoryIdForSort);
  }

  onSaveMultiEdit() {
    this.saveFlag = !this.saveFlag;
  }

  onAddCost(category: CostAccordionCategory, modalId: string) {
    this.openModal(modalId);
  }

  onSaveCategoryComment(comment: ItemGroupComment, category: CostAccordionCategory) {
    if (!comment._id) {
      this.itemGroupCommentService
        .createItemGroupComment(category.project, category._id, comment.text ?? '')
        .subscribe((c: ItemGroupComment) => {
          if (!category.comments) {
            category.comments = [];
          }
          category.comments.push({
            _id: c._id,
            createdAt: new Date(),
            text: comment.text,
          });
          category.hasComment = true;
        });
      return;
    }
    this.itemGroupCommentService
      .updateItemGroupComment(
        category.project,
        category._id,
        comment._id,
        comment.text
      )
      .subscribe();
  }

  onDeleteCategoryComment(commentId: string, category: CostAccordionCategory) {
    this.itemGroupCommentService
      .deleteItemGroupComment(category.project, commentId)
      .subscribe(() => {
        category.comments.filter((c) => c != commentId);
      });
  }

  onSelectAction(categoryId: string, selection: string) {
    this.actionSelected.emit({ categoryId: categoryId, selection: selection });
    this.modalService.closeAll();
  }

  onCostAdded(item: CostItem) {
    const cat = this.categories.find(
      (c) => c._id === this.addCostDepartmentObject._id
    );
    const c: DisplayItem = { ...item, estimatedTotal: 0 };
    cat.items = [...cat.items, c];
    this.cancelFlag = !this.cancelFlag;

    this.onRecalculate(item);
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }

  mapPositions(positions: Array<Position>) {
    return positions.map((p) => p.name);
  }

  toggleSelectAll() {
    this.selectAllFlag = !this.selectAllFlag;
  }

  onSaveDepartmentName(category: AccordionCategory, event: any) {
    event.stopPropagation();
    category.name = this.newName;
    const group: ItemGroup = {
      _id: category._id,
      department: category.department,
      name: category.name,
    };
    this.groupDataService
      .updateItemGroup(category.project, group)
      .subscribe((g) => {
        this.categories = [...this.categories];
        this.actionSelected.emit({
          categoryId: category._id,
          selection: 'Renamed',
        });
        this.newName = '';
      });
  }

  onCancelRename(categoryId: string) {
    this.newName = '';
    this.actionSelected.emit({ categoryId: categoryId, selection: 'Renamed' });
  }

  mouseDownStart = null;
  mouseDownDropped = null;
  draggableElement;

  handleDropOrder(forced?: number) {
    this.draggableElement?.remove();
    document.body.classList.remove('dragging');

    if (this.categoryDDId) {
      const costItems = this.categories.find(
        (categoryItem: any) => categoryItem._id === this.categoryDDId
      ).items;
      // console.log("\n\n\n",itemsLen,"\n\n\n");
      const [targetItem] = costItems.splice(this.mouseDownStart.itemIndex, 1);
      if (forced) {
        // Insert the target item at the new position
        costItems.splice(0, 0, targetItem);
        // console.log(
        //   'costItems\n',
        //   costItems.map((cim) => cim.orderNumber),
        //   '\n'
        // );
        // console.log(
        //   costItems.map((cim) => cim._id),
        //   ' \n\n'
        // );

        const costItemsForUpdate = costItems.map((cItem, index) => {
          return {
            id: cItem._id,
            orderNumber: index,
          };
        });

        this.itemDataService
          .updateCostItemMultipleOrderNumbers(
            this.projectId,
            costItemsForUpdate
          )
          .subscribe();
      } else if (this.mouseDownStart) {
        const fixPos =
          this.mouseDownStart.itemIndex > this.mouseDownDropped.itemIndex
            ? +1
            : 0;

        costItems.splice(
          this.mouseDownDropped.itemIndex + fixPos,
          0,
          targetItem
        );
        // console.log(
        //   'costItems\n',
        //   costItems.map((cim) => cim.orderNumber),
        //   '\n'
        // );
        // console.log(
        //   '',
        //   costItems.map((cim) => cim._id),
        //   '\n'
        // );

        // costItems.map((cItem, index)=> {
        //   return {
        //     ...cItem,
        //     orderNumber: index
        //   }
        // })
        const costItemsForUpdate = costItems.map((cItem, index) => {
          return {
            id: cItem._id,
            orderNumber: index,
          };
        });

        this.itemDataService
          .updateCostItemMultipleOrderNumbers(
            this.projectId,
            costItemsForUpdate
          )
          .subscribe();
      }
    }

    this.categoryDDId = null;
    this.mouseDownStart = null;
    this.mouseDownDropped = null;
    this.showFirstBlock = false;
  }

  onMouseDownStart(e, item, itemIndex, itemId, categoryId) {
    e.stopPropagation();
    if (itemIndex === 0) {
      this.showFirstBlock = true;
    }

    this.categoryDDId = categoryId;

    const positionRect = document
      .getElementById(itemId)
      .getBoundingClientRect();

    this.draggableElement = document.getElementById(itemId).cloneNode(true);
    this.draggableElement.firstChild.remove();
    this.draggableElement.getElementsByClassName(
      'item-wrapper'
    )[0].style.marginTop = 0;
    this.draggableElement['style'].boxShadow =
      '-3px -3px 7px rgba(116, 125, 250, 0.3), 3px 3px 7px rgba(116, 125, 250, 0.3)';
    this.draggableElement['style'].position = 'absolute';
    this.draggableElement['style'].top = e.pageY + 2 + 'px';
    this.draggableElement['style'].left = positionRect.left + 9 + 'px';
    this.draggableElement['style'].background = 'white';
    this.draggableElement['style'].opacity = 0.75;
    document.body.append(this.draggableElement);
    document.body.classList.add('dragging');
    this.mouseDownStart = { item, itemIndex };
    this.mouseDownDropped = { itemIndex: itemIndex - 1 };

    // console.log("E-start", e, "ITEM", item);
  }

  onMouseOver(e, item, itemIndex) {
    // e.stopPropagation();
    if (this.mouseDownStart) {
      this.showFirstBlock = false;
      this.mouseDownDropped = { item, itemIndex };
      // console.log("E-over", e, "ITEM", item);
    }
  }

  onMouseUp(e, item, index) {
    e.stopPropagation();
    this.handleDropOrder();
  }

  onMouseUpFirst(e) {
    e.stopPropagation();
    this.handleDropOrder(-1);
  }

  showFirstBlock = false;
  categoryDDId = '';
  onMouseOverAccordion(e) {
    if (this.mouseDownStart) {
      if (e.currentTarget.getBoundingClientRect().top > e.pageY - 30) {
        this.showFirstBlock = true;
        this.mouseDownDropped = { itemIndex: -1 };
      }
    }
  }

  get isMouseOver(): number {
    if (!this.mouseDownStart) return -1;
    if (!this.mouseDownDropped) return -1;
    return this.mouseDownDropped.itemIndex;
  }

  // BELOW PARENT DND HANDLERS AND METHODS

  mouseDownStartDepartment = null;
  mouseDownDroppedDepartment = null;
  draggableElementDepartment;

  handleDropOrderDepartment(forced?: number) {
    this.draggableElementDepartment?.remove();
    document.body.classList.remove('dragging');

    // console.log(
    //   '\n\n',
    //   this.mouseDownStartDepartment?.itemIndex,
    //   this.mouseDownDroppedDepartment?.itemIndex,
    //   '\n\n'
    // );

    // console.log("\n\n\n",itemsLen,"\n\n\n");
    if (this.mouseDownStartDepartment) {
      const [targetItem] = this.categories.splice(
        this.mouseDownStartDepartment.itemIndex,
        1
      );
      if (forced) {
        // console.log("costItems\n", costItems.map((cim)=> cim.orderNumber), "\n");
        // console.log(costItems.map((cim)=> cim._id)," \n\n");
        // costItems.map((cItem, index)=> {
        //   return {
        //     ...cItem,
        //     orderNumber: index
        //   }
        // })

        // Insert the target item at the new position
        this.categories.splice(0, 0, targetItem);
        // console.log(
        //   'costItems\n',
        //   costItems.map((cim) => cim.orderNumber),
        //   '\n'
        // );
        // console.log(
        //   costItems.map((cim) => cim._id),
        //   ' \n\n'
        // );

        const categoryItemsForUpdate = this.categories.map((cItem, index) => {
          return {
            id: cItem._id,
            orderNumber: index,
          };
        });

        this.groupDataService
          .updateItemGroupOrder(this.projectId, categoryItemsForUpdate)
          .subscribe();
      } else if (this.mouseDownStartDepartment) {
        const fixPos =
          this.mouseDownStartDepartment.itemIndex >
          this.mouseDownDroppedDepartment.itemIndex
            ? +1
            : 0;

        this.categories.splice(
          this.mouseDownDroppedDepartment.itemIndex + fixPos,
          0,
          targetItem
        );
        // console.log("costItems\n", costItems.map((cim)=> cim.orderNumber), "\n");
        // console.log("",costItems.map((cim)=> cim._id), "\n");

        // costItems.map((cItem, index)=> {
        //   return {
        //     ...cItem,
        //     orderNumber: index
        //   }
        // })

        const categoryItemsForUpdate = this.categories.map((cItem, index) => {
          return {
            id: cItem._id,
            orderNumber: index,
          };
        });

        this.groupDataService
          .updateItemGroupOrder(this.projectId, categoryItemsForUpdate)
          .subscribe();
      }
    }

    this.categoryDDIdDepartment = null;
    this.mouseDownStartDepartment = null;
    this.mouseDownDroppedDepartment = null;
    this.showFirstBlockDepartment = false;
  }

  onMouseDownStartDepartment(e, item, itemIndex, itemId, categoryId) {
    e.stopPropagation();
    if (itemIndex === 0) {
      this.showFirstBlockDepartment = true;
    }

    this.categoryDDIdDepartment = categoryId;

    const positionRect = document
      .getElementById(itemId)
      .getBoundingClientRect();

    this.draggableElementDepartment = document
      .getElementById(itemId)
      .cloneNode(true);
    // this.draggableElementDepartment.firstChild.remove();
    this.draggableElementDepartment.getElementsByClassName(
      'click-area'
    )[0].firstChild.style.minWidth = '500px';
    this.draggableElementDepartment['style'].width = '1325px';
    this.draggableElementDepartment['style'].boxShadow =
      '-3px -3px 7px rgba(116, 125, 250, 0.3), 3px 3px 7px rgba(116, 125, 250, 0.3)';
    this.draggableElementDepartment['style'].position = 'absolute';
    this.draggableElementDepartment['style'].top = e.pageY + 2 + 'px';
    this.draggableElementDepartment['style'].left =
      positionRect.left - 18 + 'px';
    this.draggableElementDepartment['style'].background = 'white';
    this.draggableElementDepartment['style'].opacity = 0.75;
    document.body.append(this.draggableElementDepartment);
    document.body.classList.add('dragging');
    this.mouseDownStartDepartment = { item, itemIndex };
    this.mouseDownDroppedDepartment = { itemIndex: itemIndex - 1 };

    // console.log("E-start", e, "ITEM", item);
  }

  onMouseOverDepartment(e, item, itemIndex) {
    // e.stopPropagation();
    if (this.mouseDownStartDepartment) {
      this.showFirstBlockDepartment = false;
      this.mouseDownDroppedDepartment = { item, itemIndex };
      // console.log("E-over", e, "ITEM", item);
    }
  }

  onMouseUpDepartment(e, item, index) {
    if (!this.haveAnyAccordionOpen) {
      e.stopPropagation();
      this.handleDropOrderDepartment();
    }
  }

  onMouseUpFirstDepartment(e) {
    e.stopPropagation();
    this.handleDropOrderDepartment(-1);
  }

  showFirstBlockDepartment = false;
  categoryDDIdDepartment = '';
  onMouseOverAccordionDepartment(e) {
    if (this.mouseDownStartDepartment) {
      if (e.currentTarget.getBoundingClientRect().top > e.pageY - 50) {
        this.showFirstBlockDepartment = true;
        this.mouseDownDroppedDepartment = { itemIndex: -1 };
      }
    }
  }

  onAddNewCost(category: CostAccordionCategory) {
    this.itemDataService
      .createCostItemByGroup(
        category._id,
        {
          position: 'NEW COST',
          currencyCode: this.companyCurrencyCode,
          exchangeRate: 1,
          days: 1,
          units: 1,
        },
        this.projectId,
        this.companyId
      )
      .subscribe((item: DisplayItem) => {
        category.items = [...category.items, item];
      });
  }

  get isMouseOverDepartment(): number {
    if (!this.mouseDownStartDepartment) return -1;
    if (!this.mouseDownDroppedDepartment) return -1;
    return this.mouseDownDroppedDepartment.itemIndex;
  }

  get companyBaseCurrencySymbol() {
    return Miscellanious.currencySymbolFromCode(
      'en-US',
      this.companyCurrencyCode
    );
  }

  @HostListener('document:keyup', ['$event']) onKeyUp(e: any) {
    if (this.selectedItems > 1 && e.key?.toUpperCase() === 'ENTER') {
      this.onSaveMultiEdit();
      return;
    }
    if (e.key === 'Enter') {
      e.stopPropagation();
    }
  }

  @HostListener('document:mouseup', ['$event']) onDocMouseUp(e: any) {
    this.handleDropOrder(this.mouseDownStart?.itemIndex);
    this.handleDropOrderDepartment(this.mouseDownStartDepartment?.itemIndex);
  }

  @HostListener('document:mousemove', ['$event']) onMouseMove(e: any) {
    if (this.mouseDownStart && this.draggableElement) {
      if (
        Math.abs(parseInt(this.draggableElement['style'].top) - (e.pageY + 5)) >
        2
      ) {
        // if(document.getElementById('accordion_'+this.categoryDDId)?.contains(e.target)) {
        this.draggableElement['style'].top = e.pageY + 5 + 'px';
        // }
      }
    }

    if (this.mouseDownStartDepartment && this.draggableElementDepartment) {
      if (
        Math.abs(
          parseInt(this.draggableElementDepartment['style'].top) - (e.pageY + 5)
        ) > 2
      ) {
        // if(document.getElementById('accordion_'+this.categoryDDId)?.contains(e.target)) {
        this.draggableElementDepartment['style'].top = e.pageY + 5 + 'px';
        // }
      }
    }
  }

  getCategoryActionMenuOptions(): ActionMenuOption[] {
    return [
      {
        label: 'productionCost.costAccordion.duplicate',
        value: 'duplicate',
      },
      {
        label: 'productionCost.costAccordion.rename',
        value: 'rename',
      },
      {
        label: 'productionCost.costAccordion.delete',
        value: 'delete',
        isDelete: true,
      },
    ];
  }

  onCategoryActionSelected(categoryId: string, action: string) {
    this.actionSelected.emit({ categoryId, selection: action });
  }

  onAddNewPaidByOption(event: { type: string }) {
    this.addNewPaidByOption.emit(event);
  }
}
